import { toast } from "react-hot-toast";
import { dispatchCustomEvent } from "./eventUtils";

const BASE_STYLE = {
  borderRadius: "14px",
  padding: "12px 16px",
  fontSize: "13px",
  fontWeight: "600",
  boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
  maxWidth: "380px",
  border: "1px solid",
};

export const showSuccessToast = (
  text: string,
  backgroundColor?: string,
  color?: string,
  dismiss: boolean = false,
  duration: number = 4000,
  customStyle?: any
) => {
  if (dismiss) toast.dismiss();

  toast.success(text, {
    duration,
    position: "top-center",
    style: {
      ...BASE_STYLE,
      background: backgroundColor ?? "#f0fdf4",
      color: color ?? "#166534",
      borderColor: "#bbf7d0",
      ...customStyle,
    },
    iconTheme: {
      primary: "#00983d",
      secondary: "#f0fdf4",
    },
  });

  dispatchCustomEvent("toast_success", { text });
};

export const showErrorToast = (
  text: string,
  backgroundColor?: string,
  color?: string,
  dismiss: boolean = false
) => {
  if (dismiss) toast.dismiss();

  toast.error(text, {
    duration: 4000,
    position: "top-center",
    style: {
      ...BASE_STYLE,
      background: backgroundColor ?? "#fef2f2",
      color: color ?? "#991b1b",
      borderColor: "#fecaca",
    },
    iconTheme: {
      primary: "#DC2626",
      secondary: "#fef2f2",
    },
  });

  dispatchCustomEvent("toast_error", { text });
};

export const showNeutralToast = (
  text: string,
  backgroundColor?: string,
  color?: string,
  dismiss: boolean = false
) => {
  if (dismiss) toast.dismiss();

  toast(text, {
    duration: 4000,
    position: "top-center",
    style: {
      ...BASE_STYLE,
      background: backgroundColor ?? "#ffffff",
      color: color ?? "#1D2530",
      borderColor: "#E2E5E9",
    },
  });

  dispatchCustomEvent("toast_neutral", { text });
};

export const showSeatUnavailableToast = (
  text: string,
  backgroundColor?: string,
  color?: string,
  dismiss: boolean = false
) => {
  if (dismiss) toast.dismiss();

  toast(text, {
    duration: 5000,
    position: "top-center",
    style: {
      ...BASE_STYLE,
      background: backgroundColor ?? "#1D2530",
      color: color ?? "#ffffff",
      borderColor: "#374151",
    },
  });

  dispatchCustomEvent("toast_seat_unavailable", { text });
};
